import ReactDOM from 'react-dom';
import React from 'react';
import Bluebird from 'bluebird';
import { AppContainer } from 'react-hot-loader';
import App from './containers/Main';

window.Promise = Bluebird;

const render = (Component) => {
    ReactDOM.render(
        <AppContainer>
            <Component />
        </AppContainer>,
        document.getElementById('root')
    )
}

render(App);

if (module.hot) {
    module.hot.accept('./containers/Main', () => {
        render(App)
    });
}

//jenkinstest


// WEBPACK FOOTER //
// ./index.js